module.exports = __webpack_public_path__ + "img/2.c93b1ce2.png";